<template>
    <div class="profile">
        <h1>PROFILE Page done</h1>
    </div>
</template>

<script>
    export default {
        name: "Profile"
    }
</script>

<style scoped>

</style>